import React from 'react';

const Footer = () => {
  return (
    <footer style={{ 
      textAlign: 'center', 
      padding: '20px', 
      backgroundColor: '#1E1E1E',
      marginTop: '40px',
      borderTop: '1px solid #333'
    }}>
      <p style={{ color: '#FFFFFF', margin: '0 0 10px 0' }}>
        © 2025 DiagramLoom. All rights reserved.
      </p>
      <p style={{ color: '#FF9900', margin: 0, fontSize: '0.9rem' }}>
        Transform your ideas into professional diagrams
      </p>
    </footer>
  );
};

export default Footer;